/**
 * Hours formatting utilities.
 *
 * formatHours(v) rounds the value to the nearest 0.5 and returns a string:
 *   - whole numbers stay whole ("4", "12")
 *   - half-hour values keep one decimal ("4.5", "7.5")
 *
 * Examples:
 *   formatHours(4)     -> "4"
 *   formatHours(4.5)   -> "4.5"
 *   formatHours(4.4)   -> "4.5"   (rounds up to nearest .5)
 *   formatHours(4.2)   -> "4"
 *   formatHours(undefined) -> "0"
 */
export function formatHours(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "0";
  const half = Math.round(n * 2) / 2;
  return half % 1 === 0 ? half.toFixed(0) : half.toFixed(1);
}

// Alias kept short for ergonomic use in JSX: {fh(task.actual_hours)}
export const fh = formatHours;
